import React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

const toDayjs = (value) => {
    if (value === undefined || value === null || value === "") return null;
    if (dayjs.isDayjs(value)) return value.isValid() ? value : null;
    const d = dayjs(value);
    return d.isValid() ? d : null;
};

const AppDatePicker = ({
    label,
    name,
    value,
    onChange,
    helperText,
    error,
    required = false,
    disabled = false,
    readOnly = false,
    minDate,
    maxDate,
    fullWidth = true,
    size = "medium",
    format = "MM/DD/YYYY",
    slotProps,
    ...rest
}) => {
    const handleChange = (next) => {
        if (typeof onChange !== "function") return;
        if (next && dayjs.isDayjs(next) && next.isValid()) {
            onChange(next.format("YYYY-MM-DD"), name);
        } else {
            onChange("", name);
        }
    };

    const callerTextFieldSlot = (slotProps && slotProps.textField) || {};
    const mergedSlotProps = {
        ...(slotProps || {}),
        textField: {
            name,
            fullWidth,
            size,
            required,
            helperText,
            // Only forwarded when the caller has an opinion: a hardcoded value would also silence
            // the picker's own minDate/maxDate and unparseable-date validation.
            ...(error === undefined ? {} : { error }),
            ...callerTextFieldSlot,
        },
    };

    return (
        <DatePicker
            label={label}
            value={toDayjs(value)}
            onChange={handleChange}
            format={format}
            disabled={disabled}
            readOnly={readOnly}
            minDate={toDayjs(minDate) || undefined}
            maxDate={toDayjs(maxDate) || undefined}
            slotProps={mergedSlotProps}
            {...rest}
        />
    );
};

export default AppDatePicker;
